export const detailedTransactions = {
	tabTitle: "Venda detalhada",
	header: {
		title: "Relatório de Venda detalhada",
		subtitle:
			"Acompanhe os produtos vendidos e visualize suas vendas de forma detalhada.",
		exportButton: "Exportar",
		exportLoading: "Exportando...",
		exportNotification:
			"o relatório será gerado e assim que estiver pronto será enviado para o seu e-mail ({{email}})",
	},
	inlineFilters: {
		customerPlaceholder: "Filtrar por cliente",
		employeesPlaceholder: "Filtrar por colaborador",
		paymentMethodsPlaceholder: "Filtrar por tipo de pagamento",
		filtersButton: "Filtros",
	},
	table: {
		dateTime: "DATA / HORA",
		customer: "CLIENTE",
		document: "DOCUMENTO",
		seller: "COLABORADOR",
		products: "PRODUTOS",
		paymentMethods: "FORMA DE PAGAMENTO",
		refunded: "ESTORNADO?",
		refundedBadge: "ESTORNADO",
		discount: "DESCONTO",
		value: "VALOR DA TRANSAÇÃO",
		totalRow: "Total",
		emptyCustomer: "Venda Avulsa",
		emptyValue: "-",
		productsCount: "{{count}} produtos",
		productsCount_one: "{{count}} produto",
		productsCount_other: "{{count}} produtos",
		paymentMethodsCount: "{{count}} métodos",
		paymentMethodsCount_one: "{{count}} método",
		paymentMethodsCount_other: "{{count}} métodos",
		emptyState: {
			noData: {
				title: "Nenhuma transação encontrada",
				description:
					"Não há transações registradas no período selecionado. Quando novas vendas ocorrerem, elas aparecerão aqui.",
			},
			noFilters: {
				title: "Nenhuma transação para os filtros aplicados",
				description:
					"Tente ajustar o período, cliente, colaborador, forma de pagamento ou setor para encontrar o que procura.",
			},
		},
		pagination: {
			pageSizeLabel: "Resultados por página",
		},
	},
	expandedProducts: {
		name: "Produto",
		fiscalCode: "Cód. fiscal",
		category: "Categoria",
		count: "Qtd",
		value: "Valor unit",
		discount: "Desconto",
		total: "Total",
	},
	filterModal: {
		title: "Filtros",
		cancel: "Cancelar",
		clearFilters: "Limpar filtros",
		apply: "Aplicar",
		filteredBy: "Filtrado por",
		filterOptionsLabel: "Opções de filtro",
		clearSelection: "Limpar seleção",
		nav: {
			dateOrPeriod: "Data ou período",
			operation: "Cliente e colaborador",
			payment: "Pagamento",
			sector: "Setor",
		},
		period: {
			today: "Hoje",
			yesterday: "Ontem",
			last30Days: "Últimos 30 dias",
			customPeriod: "Período personalizado",
		},
		periodLabels: {
			today: "Hoje",
			yesterday: "Ontem",
			last_30_days: "Últimos 30 dias",
			custom: "Personalizado",
		},
		activeFilterLabels: {
			period: "período",
			customer: "cliente",
			employee: "colaborador",
			payment: "pagamento",
			sector: "setor",
		},
		operationSection: {
			customerLabel: "Cliente",
			customerPlaceholder: "Filtrar por cliente",
			employeeLabel: "Colaborador",
			employeePlaceholder: "Filtrar por colaborador",
			noEmployeeFound: "Nenhum colaborador encontrado",
		},
		paymentSection: {
			paymentLabel: "Forma de pagamento",
			paymentPlaceholder: "Filtrar por tipo de pagamento",
			noPaymentFound: "Nenhuma forma de pagamento encontrada",
		},
		sectorSection: {
			sectorLabel: "Setor",
			sectorPlaceholder: "Filtrar por setor",
			noSectorFound: "Nenhum setor encontrado",
		},
	},
};
